package fr.manyverse.app.domain.usecase

import fr.manyverse.app.domain.model.FeedbackType
import fr.manyverse.app.domain.repository.UserFeedbackRepository
import fr.manyverse.app.domain.validation.FeedbackValidator

class SendUserFeedbackUseCase(
    private val userFeedbackRepository: UserFeedbackRepository
) {
    suspend operator fun invoke(
        userId: String,
        userEmail: String,
        type: FeedbackType,
        message: String
    ): Result<Unit> {
        val validationError = FeedbackValidator.validate(message)
        if (validationError != null) {
            return Result.failure(validationError)
        }
        return userFeedbackRepository.submitFeedback(userId, userEmail, type, message)
    }
}
